import { render } from "./Substitut.vue?vue&type=template&id=5bc5e8ba&scoped=true"
import script from "./Substitut.vue?vue&type=script&lang=js"
export * from "./Substitut.vue?vue&type=script&lang=js"

import "./Substitut.vue?vue&type=style&index=0&id=5bc5e8ba&scoped=true&lang=css"

import exportComponent from "/var/www/share/bb5.highdigital.de/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc5e8ba"]])

export default __exports__